module.exports = __webpack_public_path__ + "img/hero-dots-1.746881dc.png";